import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { toast } from 'sonner';
import { subscribeNewsletter } from '../services/api';

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribing, setSubscribing] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setSubscribing(true);
    try {
      const result = await subscribeNewsletter(email);
      toast.success(result.message || 'Thank you for subscribing to our newsletter!');
      setEmail('');
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      toast.error('Failed to subscribe. Please try again.');
    } finally {
      setSubscribing(false);
    }
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-brand">
              <Leaf className="footer-logo-icon" />
              <span className="footer-brand-text">Remedy Essentials Store</span>
            </div>
            <p className="footer-description">
              Let us cater to your spiritual essential needs. We strive to support your spiritual journey by supplying you items you may need to facilitate your spiritual growth.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/shop" className="footer-link">Shop All</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
              <li><Link to="/shop?category=soaps" className="footer-link">Soaps</Link></li>
              <li><Link to="/shop?category=crystals" className="footer-link">Crystals</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="footer-section">
            <h3 className="footer-title">Customer Service</h3>
            <ul className="footer-links">
              <li><a href="#" className="footer-link">Shipping Info</a></li>
              <li><a href="#" className="footer-link">Returns & Exchanges</a></li>
              <li><a href="#" className="footer-link">FAQ</a></li>
              <li><a href="#" className="footer-link">Privacy Policy</a></li>
              <li><a href="#" className="footer-link">Terms of Service</a></li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div className="footer-section">
            <h3 className="footer-title">Get In Touch</h3>
            <div className="contact-info">
              <div className="contact-item">
                <Mail size={16} />
                <span>naturalsupplies@remedyessentialsstore.com</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span>510-253-7314</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Des Moines, IA 50312</span>
              </div>
            </div>
            
            <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
              <h4 className="newsletter-title">Newsletter</h4>
              <div className="newsletter-input-group">
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="newsletter-input"
                />
                <button type="submit" className="newsletter-button" disabled={subscribing}>
                  {subscribing ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Remedy Essentials Store. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
